import type { TLang } from 'src/constants/langs'

interface ITextBtn {
    lang: TLang
    text: string
}

export const textBtn: ITextBtn[] = [
    {
        lang: 'ro',
        text: 'joacă',
    },
    {
        lang: 'de',
        text: 'Spielen',
    },
    {
        lang: 'es',
        text: 'Jugar',
    },
    {
        lang: 'en',
        text: 'Play',
    },
]
